import ButtonSmall from './ButtonSmall';

export default ButtonSmall;